<template>
    <div class="qksm qksm7">
        <h4>七、关于{{$store.state.divData.divname}}2022年一般公共预算“三公”经费预算情况说明</h4>
        <div class="nogap">
            <p>
                {{$store.state.divData.divname}}2022年一般公共预算“三公”经费预算数为{{isMoney(T7.三公总计)}}万元，
                <template v-if="num(T7.三公总计)==num(T7.三公总计last)">
                    与上年相同，
                </template>
                <template v-else>
                    比上年{{growthValueText(T7.三公总计, T7.三公总计last)}}万元，
                </template>
                其中：因公出国（境）费{{isMoney(T7.因公出国)}}万元，{{growthValueText(T7.因公出国, T7.因公出国last)}}万元；
                公务用车购置及运行费{{isMoney(T7.公务用车购置及运行费)}}万元，{{growthValueText(T7.公务用车购置及运行费, T7.公务用车购置及运行费last)}}万元；
                公务接待费{{isMoney(T7.公务接待费)}}万元，{{growthValueText(T7.公务接待费, T7.公务接待费last)}}万元。
                <template v-if="num(T7.三公总计)==num(T7.三公总计last)">
                    2022年“三公”经费预算与上年相同。
                </template>
                <template v-else>
                    2022年“三公”经费预算比上年{{T7.三公总计 >= T7.三公总计last ? "增加" : "减少"}}主要是
                    <reason type="textarea" classname="qksm widest" name="原因_三公经费" v-model:value="qksm['原因_三公经费']"></reason>
                </template>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm7",
        props: {
            T7: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },

    };
</script>